import { API_AXIOS_INSTANCE } from "@elation/api-client/src/core";

import { IS_CHROME_EXTENSION, IS_IN_IFRAME, SERVICE_URL } from "@src/env";
import { getBearerAuthToken, usesBearerAuth } from "@src/features/auth";
import { getIframeEhr } from "@src/features/iframe";
import { getCsrfToken, setCsrfFromResponse } from "@src/shared/utils/auth/csrf";

API_AXIOS_INSTANCE.defaults.baseURL = SERVICE_URL;
API_AXIOS_INSTANCE.defaults.withCredentials = !usesBearerAuth();

API_AXIOS_INSTANCE.interceptors.request.use(async (config) => {
  if (IS_IN_IFRAME) {
    config.headers["X-EL8-In-Iframe"] = true;
    config.headers["X-EL8-EHR"] = getIframeEhr();
  }

  if (config.url?.startsWith("/gw/stitch-web")) {
    config.url = config.url.replace("/gw/stitch-web", "");
  }

  if (IS_CHROME_EXTENSION) {
    config.headers["X-EL8-API-CLIENT-CONTEXT"] = "extension";
  } else {
    config.headers["X-EL8-API-CLIENT-CONTEXT"] = "browser";
  }

  const csrfToken = await getCsrfToken();
  config.headers["X-CSRFToken"] = csrfToken || "";

  if (usesBearerAuth()) {
    const token = await getBearerAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn("[initApiClient] Missing bearer token in bearer-auth mode", {
        url: config.url,
        errorIds: ["auth.bearer_token_missing"],
      });
    }
  }

  return config;
});

API_AXIOS_INSTANCE.interceptors.response.use((response) => {
  setCsrfFromResponse();
  return response;
});
